"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var detectBreakpoint_1 = require("../../../../src/detectBreakpoint");
var throttle_1 = require("../../../../src/throttle");
var React = __importStar(require("react"));
var react_transition_group_1 = require("react-transition-group");
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line:member-ordering
        _this.closeOnResize = (0, throttle_1.throttle)(function () {
            var _a = _this.props, close = _a.close, closeBreakpoint = _a.closeBreakpoint, opened = _a.opened;
            if ((0, detectBreakpoint_1.detectBreakpoint)(closeBreakpoint) && opened === true) {
                close();
            }
        }, 100);
        return _this;
    }
    Sidebar.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.closeOnResize);
    };
    Sidebar.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.closeOnResize);
    };
    Sidebar.prototype.render = function () {
        var _a = this.props, opened = _a.opened, children = _a.children, className = _a.className, close = _a.close;
        var classes = className ? "sidebar ".concat(className) : "sidebar";
        return (React.createElement("div", null,
            React.createElement("div", { "data-testid": "overlay", className: opened ? "overlay" : null, onClick: close }),
            React.createElement(react_transition_group_1.TransitionGroup, null, opened ?
                React.createElement(react_transition_group_1.CSSTransition, { key: "sidebar", classNames: "sidebar--slide", timeout: 300 },
                    React.createElement("div", { className: classes }, children)) : null)));
    };
    return Sidebar;
}(React.Component));
exports.default = Sidebar;
